import React from "react";
import Item from "./Item";
import cx from "classnames";
import styles from "./PersonalizationAndDetails.module.scss";
import { usePageContext } from "@providers/PageProvider";
import { meetingPage } from "@utils/helper";
import _ from "lodash";
const OPPOSITION = {
  left: "right",
  right: "left",
};
export default function PersonalizationAndDetails() {
  const { pageData } = usePageContext();
  const details = meetingPage.formatPersonalizationAndDetails(pageData);

  return (
    <div
      data-scroll-section
      className={cx("flex flex-col items-center", styles.section)}
    >
      <div className={cx(styles.sectionTitle)}>{_.get(details, "title")}</div>
      {_.map(_.get(details, "items", []), (item: any, index: number) => {
        return (
          <Item
            shouldActionMore
            className={cx(styles.item1)}
            images={[
              {
                ...(_.get(item, "image") || { src: "", alt: "" }),
                placement: _.get(item, "imagePosition", "right"),
              },
            ]}
            aside={{
              placement: _.get(
                OPPOSITION,
                _.get(item, "imagePosition", "right")
              ),
              className: cx(styles.asideItem1),
              content: {
                className: cx({
                  [styles.contentItem1]: index % 2 === 0,
                  [styles.contentItem2]: index % 2 !== 0,
                }),
                title: _.get(item, "title"),
                text: _.get(item, "content"),
              },
            }}
            button={_.get(item, "button")}
          />
        );
      })}
    </div>
  );
}
